"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isAnyFlashcardsWithBacks = exports.isAnyNonBootcampSentenceFlashcardOrFlashcardBackType = exports.validateCreatedFlashcardList = exports.isFlashcardsForReviewSessionData = exports.FlashcardsForReviewSessionDataSchema = exports.isAnyFlashcardOrFlashcardBack = exports.isAnyWordRelatedFlashcard = exports.isAnyFlashcard = void 0;
const zod_1 = require("zod");
const type_validation_helpers_1 = require("../../helpers/type_validation_helpers");
const bootcamp_sentence_types_1 = require("../sentence/bootcamp_sentence_types");
const sentence_types_1 = require("../sentence/sentence_types");
const sentence_word_types_1 = require("../sentence/sentence_word_types");
const flashcard_back_type_types_1 = require("./flashcard_back_type_types");
const flashcard_back_types_1 = require("./flashcard_back_types");
const premade_flashcard_types_1 = require("./premade_flashcard_types");
const sentence_flashcard_type_types_1 = require("./sentence_flashcard_type_types");
const sentence_flashcard_types_1 = require("./sentence_flashcard_types");
const word_flashcard_types_1 = require("./word_flashcard_types");
const AnyFlashcardSchema = zod_1.z.union([
    premade_flashcard_types_1.AnyPremadeFlashcardSchema,
    sentence_flashcard_types_1.AnySentenceFlashcardSchema,
    word_flashcard_types_1.AnyWordFlashcardSchema,
]);
exports.isAnyFlashcard = type_validation_helpers_1.getTypeValidationFunction(AnyFlashcardSchema);
const AnyWordRelatedFlashcardSchema = zod_1.z.union([
    premade_flashcard_types_1.AlphabetFlashcardSchema,
    premade_flashcard_types_1.MissingLetterFlashcardSchema,
    word_flashcard_types_1.PicToWordFlashcardSchema,
    premade_flashcard_types_1.PronounceFlashcardSchema,
    premade_flashcard_types_1.SpellingFlashcardSchema,
    premade_flashcard_types_1.StrokeOrderFlashcardSchema,
    premade_flashcard_types_1.ToneFlashcardSchema,
    premade_flashcard_types_1.WordStressFlashcardSchema,
    word_flashcard_types_1.WordToAnyFlashcardSchema,
]);
exports.isAnyWordRelatedFlashcard = type_validation_helpers_1.getTypeValidationFunction(AnyWordRelatedFlashcardSchema);
const AnyFlashcardOrFlashcardBackSchema = zod_1.z.union([
    AnyFlashcardSchema,
    flashcard_back_types_1.AnyFlashcardBackSchema,
]);
exports.isAnyFlashcardOrFlashcardBack = type_validation_helpers_1.getTypeValidationFunction(AnyFlashcardOrFlashcardBackSchema);
const FlashcardsDataSchema = zod_1.z.object({
    flashcards: AnyFlashcardSchema.array(),
});
exports.FlashcardsForReviewSessionDataSchema = FlashcardsDataSchema.extend({
    sentences: zod_1.z
        .union([
        sentence_types_1.AnySentenceWordSentenceWithSpecialWordDataSchema,
        bootcamp_sentence_types_1.BootcampSentenceSchema,
    ])
        .array(),
    tags: sentence_word_types_1.TagSchema.array(),
});
exports.isFlashcardsForReviewSessionData = type_validation_helpers_1.getTypeValidationFunction(exports.FlashcardsForReviewSessionDataSchema);
const CreatedFlashcard = zod_1.z.object({
    id: zod_1.z.string(),
});
const CreatedFlashcardList = CreatedFlashcard.array();
const validateCreatedFlashcardList = (x) => CreatedFlashcardList.safeParse(x);
exports.validateCreatedFlashcardList = validateCreatedFlashcardList;
const AnyNonBootcampSentenceFlashcardOrFlashcardBackTypeSchema = zod_1.z.union([
    sentence_flashcard_type_types_1.AnyNonBootcampSentenceFlashcardTypeSchema,
    flashcard_back_type_types_1.AnyNonBootcampSentenceFlashcardBackTypeSchema,
]);
exports.isAnyNonBootcampSentenceFlashcardOrFlashcardBackType = type_validation_helpers_1.getTypeValidationFunction(AnyNonBootcampSentenceFlashcardOrFlashcardBackTypeSchema);
const AnyFlashcardWithBacksSchema = zod_1.z.union([
    sentence_flashcard_types_1.BootcampWordToSentenceFlashcardSchema,
    word_flashcard_types_1.WordToAnyFlashcardSchema,
]);
exports.isAnyFlashcardsWithBacks = type_validation_helpers_1.getTypeValidationFunction(AnyFlashcardWithBacksSchema);
//# sourceMappingURL=flashcard_types.js.map